// 创建文件zh.js
const zh = {
    building_des: '楼栋简介',
    title: '沧海校区致理楼健康监测系统',
    wind_direction: '风向',
    wind_power: '风力',
    wind_speed: '风速',
    mon: '一',
    sat: '六',
    sun: '日',
    tues: '二',
    wed: '三',
    thus: '四',
    fri: '五',
    detail_pr: '详细工程信息',
    node_status: '节点状态统计',
    total: '总数',
    node_power: '节点电量统计',
    time: '时域图',
    time_detail: '详细',
    a_alarm: '加速度阈值告警',
    f_alarm: '基础频率阈值告警',
    type: '结构类型',
    wall: '框架-剪力墙',
    visitors_flowrate: '人流量',
    people_hour: '人/时',
    area: '建筑面积',
    class_room: '教室',
    main_build: '主楼(17层)',
    annex: '附楼(7层)',
    meeting_room: '会议室',
    elevator: '楼电梯',
    online: '在线',
    offline: '休眠',
    abnormal: '异常',
    status: '状态',
    tai: '台',
    n_status: '节点状态',
    soc: '剩余电量',
    today_alarm: '今日报警',
    month_alarm: '本月报警',
    times: '次数',
    health: '健康状况',
    day: '日',
    month: '月',
    year: '年',
    back: '返回主页',
    freq_chart: '频域图',
    time_chart: '时域曲线图',
    load: '加载中',
    normal: '正常',
    anomaly: '异常',



}
export default zh;



// WEBPACK FOOTER //
// ./src/lang/zh.js